module.exports = __webpack_public_path__ + "public/img/yuanhuan.19d51568.png";